import { Page } from "components/Page";
import ImageUpload from "features/uploads/ImageUpload";

export const ImageUploadPage = () => {
  return (
    <Page title="Docs Upload">
      <ImageUpload />
    </Page>
  );
};
